import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as t } from "../chunks/tslib.es6.js";
import o from "../core/Logger.js";
import { throwIfAborted as r } from "../core/promiseUtils.js";
import { property as e } from "../core/accessorSupport/decorators/property.js";
import "../core/arrayUtils.js";
import "../core/has.js";
import "../core/accessorSupport/ensureType.js";
import { enumeration as s } from "../core/accessorSupport/decorators/enumeration.js";
import { subclass as l } from "../core/accessorSupport/decorators/subclass.js";
import p from "../portal/Portal.js";
import { r as i, w as m } from "../chunks/persistableUrlUtils.js";
import a from "./Symbol.js";
import y from "./support/Thumbnail.js";

var _c;

var n = o.getLogger("esri.symbols.WebStyleSymbol");

var u = _c = /*#__PURE__*/function (_a) {
  _inherits(c, _a);

  var _super = _createSuper(c);

  function c(t) {
    var _this;

    _classCallCheck(this, c);

    _this = _super.call(this, t), _this.styleName = null, _this.portal = null, _this.styleUrl = null, _this.thumbnail = null, _this.name = null, _this.type = "web-style";
    return _this;
  }

  _createClass(c, [{
    key: "read",
    value: function read(t, o) {
      this.portal = o ? o.portal : void 0, _get(_getPrototypeOf(c.prototype), "read", this).call(this, t, o);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new _c({
        name: this.name,
        styleUrl: this.styleUrl,
        styleName: this.styleName,
        portal: this.portal
      });
    }
  }, {
    key: "fetchSymbol",
    value: function fetchSymbol(t) {
      return this._fetchSymbol("webRef", t);
    }
  }, {
    key: "fetchCIMSymbol",
    value: function fetchCIMSymbol(t) {
      return this._fetchSymbol("cimRef", t);
    }
  }, {
    key: "_fetchSymbol",
    value: function () {
      var _fetchSymbol2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(t, o) {
        var e, s;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return b();

              case 2:
                e = _context.sent;
                r(o);
                s = e.resolveWebStyleSymbol(this, {
                  portal: this.portal
                }, t, o);
                return _context.abrupt("return", (s.catch(function (t) {
                  n.error("#fetchSymbol()", "Failed to create symbol from style", t);
                }), s));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _fetchSymbol(_x, _x2) {
        return _fetchSymbol2.apply(this, arguments);
      }

      return _fetchSymbol;
    }()
  }]);

  return c;
}(a);

function b() {
  return import("./support/webStyleSymbolUtils.js");
}

t([e({
  json: {
    write: !1
  }
})], u.prototype, "color", void 0), t([e({
  type: String,
  json: {
    write: !0
  }
})], u.prototype, "styleName", void 0), t([e({
  type: p,
  json: {
    write: !1
  }
})], u.prototype, "portal", void 0), t([e({
  type: String,
  json: {
    read: i,
    write: m
  }
})], u.prototype, "styleUrl", void 0), t([e({
  type: y,
  json: {
    read: !1
  }
})], u.prototype, "thumbnail", void 0), t([e({
  type: String,
  json: {
    write: !0
  }
})], u.prototype, "name", void 0), t([s({
  styleSymbolReference: "web-style"
}, {
  readOnly: !0
})], u.prototype, "type", void 0), u = _c = t([l("esri.symbols.WebStyleSymbol")], u);
var h = u;
export { h as default };